document.addEventListener('DOMContentLoaded', () => {
  let bookmarkSubmissionForm = document.getElementById('bookmark-submission-form');
  if (bookmarkSubmissionForm) {
    bookmarkSubmissionForm.focus();
  }
});